import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
/**
 * 作业票图层
 */
class WorkOrderLayer extends BaseLayer{

    constructor(options={}){
        options.layerName=options.layerName||CONSTANTS.LAYER.WORKORDER;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.forEach((obj,index) =>{
            let item={...obj.attributes};
            if(item.workStatus==1){
                item.layerName=self.layerName;
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude, CONSTANTS.ALTITUDE),
                    name: item.name,
                    id:item.id,
                    attributes:item,
                    //立广告牌
                    billboard :{
                        image : require("@/assets/img/map/icon_otm.png"),
                        show : true,
                        width : 75,
                        height : 70,
                        pixelOffset:new Cesium.Cartesian2(-10, 0),
                        heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });
    }
}
export default WorkOrderLayer;
